import request from '@/utils/request'

export function getOfficeContractList (params) {
  return request({
    url: '/v2/sec/officeContract/getOfficeContractList',
    method: 'post',
    data: params
  })
}
export function getOfficeContractDetail (params) {
  return request({
    url: '/v2/sec/officeContract/getOfficeContractDetail',
    method: 'post',
    data: params
  })
}
export function inspectContactInfo () {
  return request({
    url: '/v2/sec/officeContract/inspectContactInfo',
    method: 'post'
  })
}
export function uploadOfficeContract (params) {
  return request({
    url: '/v2/sec/officeContract/upload',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: params
  })
}
export function deleteUploadedCtr (params) {
  return request({
    url: '/v2/sec/officeContract/deleteUploadedCtr',
    method: 'post',
    data: params
  })
}
export function pdfConversionRequestOfficeCtr (params) {
  return request({
    url: '/v2/sec/officeContract/pdfConversion',
    method: 'post',
    params
  })
}
export function confirmUsePoint (params) {
  return request({
    url: '/v2/sec/officeContract/confirmUsePoint',
    method: 'post',
    data: params
  })
}
export function officeCtrRequest (params) {
  return request({
    url: '/v2/sec/officeContract/officeCtrRequest',
    method: 'post',
    params
  })
}
export function retryUploadOfficeCtrFile (params) {
  return request({
    url: '/v2/sec/officeContract/retryUpload',
    method: 'post',
    data: params
  })
}